import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'purple' | 'subtle';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  icon?: React.ReactNode;
  dot?: boolean;
}
export function Badge({
  children,
  variant = 'default',
  size = 'md',
  className = '',
  icon,
  dot = false
}: BadgeProps) {
  const baseStyles = 'inline-flex items-center rounded-full font-medium';
  const variantStyles = {
    default: 'bg-gray-100 text-gray-800',
    primary: 'bg-[#B61C1C] text-white',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
    danger: 'bg-red-100 text-red-800',
    info: 'bg-blue-100 text-blue-800',
    purple: 'bg-purple-100 text-purple-800',
    subtle: 'bg-gray-50 text-gray-600 border border-gray-200'
  };
  const sizeStyles = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm'
  };
  return <span className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} data-id="element-3691">
      {dot && <span className={`mr-1.5 h-2 w-2 rounded-full ${variant === 'primary' ? 'bg-white' : variant === 'success' ? 'bg-green-500' : variant === 'warning' ? 'bg-yellow-500' : variant === 'danger' ? 'bg-red-500' : variant === 'info' ? 'bg-blue-500' : variant === 'purple' ? 'bg-purple-500' : 'bg-gray-500'}`} data-id="element-3692"></span>}
      {icon && <span className="mr-1" data-id="element-3693">{icon}</span>}
      {children}
    </span>;
}